@if (embedData) {
  <div class="relative w-full aspect-square rounded overflow-hidden">
    @if (embedData.cover) {
      <img [src]="embedData.cover" class="relative w-full h-full object-cover" />
    } @else {
      <div class="relative w-full h-full bg-slate-200"></div>
    }
  </div>
  <button class="w-full py-1 bg-[#0047FF] text-white rounded" (click)="fileInput.click()">
    Upload
  </button>
  <input type="file" class="hidden" (change)="onChangeFile($event)" #fileInput />
  <textarea
    rows="4"
    class="w-full px-2 pt-2 ring-2 ring-[#0047FF] rounded-xl bg-white text-sm text-gray-800 dark:text-white resize-none"
    [value]="iframeCode"
    readonly
  ></textarea>
  <div class="relative w-[90%] flex flex-row justify-between items-center">
    <p class="text-gray-800 dark:text-white text-xs lg:text-base">Capture Active</p>
    <mat-slide-toggle [(ngModel)]="embedData.isCapture" (ngModelChange)="onChangeCapture()">
    </mat-slide-toggle>
  </div>
  <div class="relative w-[90%] flex flex-row justify-between items-center">
    <p class="text-gray-800 dark:text-white text-xs lg:text-base">Full Screen Active</p>
    <mat-slide-toggle [(ngModel)]="embedData.isFullScreen" (ngModelChange)="onChangeFullScreen()">
    </mat-slide-toggle>
  </div>
  <div class="relative w-[90%] flex flex-row justify-between items-center">
    <p class="text-gray-800 dark:text-white text-xs lg:text-base">Auto Rotation Active</p>
    <mat-slide-toggle [(ngModel)]="embedData.isAutoRotation" (ngModelChange)="onChangeAutoRotate()">
    </mat-slide-toggle>
  </div>
  <button class="w-full flex justify-center items-center py-1 bg-[#0047FF] rounded">Copy</button>
}
